import { useState } from 'react';

/* Checklist multi-seleção — grade de botões quando poucas opções (≤ threshold),
 * lista com busca por nome quando muitas (ex: uma empresa com 60 áreas cadastradas
 * ficaria impraticável como grade de botões). Mesmo padrão visual do seletor de
 * empresa da topbar (AppLayout), adaptado para seleção múltipla via checkbox. */
export default function MultiSelectBusca({
  options,
  selected,
  onToggle,
  threshold = 5,
  placeholder = 'Buscar...',
  vazioLabel = 'Nenhum resultado encontrado.',
}) {
  const [busca, setBusca] = useState('');
  const usarBusca = options.length > threshold;

  if (!usarBusca) {
    return (
      <div className="d-flex flex-wrap gap-2 mt-1">
        {options.map(o => (
          <button key={o.value} type="button"
            className={`btn btn-sm ${selected.includes(o.value) ? 'btn-primary' : 'btn-outline-secondary'}`}
            onClick={() => onToggle(o.value)}>
            {o.label}
          </button>
        ))}
      </div>
    );
  }

  const filtradas = options.filter(o => o.label.toLowerCase().includes(busca.trim().toLowerCase()));

  return (
    <div className="cjc-checklist mt-1">
      <div className="cjc-checklist-search">
        <input
          className="form-control form-control-sm"
          value={busca}
          onChange={e => setBusca(e.target.value)}
          placeholder={placeholder}
        />
      </div>
      <div className="cjc-checklist-list">
        {filtradas.length === 0 ? (
          <div className="cjc-checklist-vazio">{vazioLabel}</div>
        ) : (
          filtradas.map(o => (
            <label key={o.value} className="cjc-checklist-item">
              <input type="checkbox" checked={selected.includes(o.value)} onChange={() => onToggle(o.value)} />
              <span>{o.label}</span>
            </label>
          ))
        )}
      </div>
      {selected.length > 0 && (
        <div className="text-muted mt-1" style={{ fontSize: 12 }}>
          {selected.length} selecionada(s)
        </div>
      )}
    </div>
  );
}
